function init_hallanim(from_php){
    var main=$(".place.hallanim");
    var spineResource;
    if(from_php.girl_id==0){
        return false;
    }
    if(_ON_DEV){
        console.log(from_php)
    }
    var girl_conf={

alice_cat:{width:80,height:112,left:1846,top:51,map:[]},//left:1586,top:391
alice_girl:{width:172,height:399,left:1767,top:160,map:[]},
anya_cat:{width:76,height:96,left:1573,top:436,map:[]},
anya_girl:{width:126,height:380,left:1482,top:202,map:[]},
ashley_cat:{width:68,height:100,left:1180,top:378,map:[]},
ashley_girl:{width:157,height:355,left:1186,top:176,map:[]},
cherry_cat:{width:111,height:111,left:1373,top:538,map:[]},
cherry_girl:{width:252,height:275,left:1284,top:398,map:[]},
cindy_cat:{width:95,height:105,left:1214,top:613,map:[]},
cindy_girl:{width:282,height:320,left:1122,top:460,map:[]},
dora_cat:{width:88,height:96,left:203,top:442,map:[]},
dora_girl:{width:291,height:398,left:147,top:151,map:[]},
emma_cat:{width:97,height:104,left:311,top:515,map:[]},
emma_girl:{width:266,height:278,left:250,top:392,map:[]},
frecly_cat:{width:86,height:57,left:660,top:443,map:[]},
frecly_girl:{width:171,height:369,left:585,top:171,map:[]},
geeky_cat:{width:122,height:106,left:74,top:591,map:[]},
geeky_girl:{width:209,height:409,left:50,top:326,map:[]},
ice_cat:{width:84,height:88,left:634,top:505,map:[]},
ice_girl:{width:235,height:243,left:481,top:412,map:[]},
indira_cat:{width:60,height:74,left:568,top:444,map:[]},
indira_girl:{width:121,height:362,left:517,top:179,map:[]},
linn_cat:{width:105,height:121,left:1851,top:538,map:[]},
linn_girl:{width:199,height:433,left:1761,top:305,map:[]},
lola_cat:{width:81,height:116,left:1680,top:419,map:[]},
lola_girl:{width:246,height:351,left:1605,top:276,map:[]},
maggie_cat:{width:92,height:121,left:1727,top:637,map:[]},
maggie_girl:{width:474,height:387,left:1549,top:392,map:[]},
pantress_cat:{width:115,height:117,left:1475,top:609,map:[]},
pantress_girl:{width:304,height:242,left:1403,top:538,map:[]},
sanshi_cat:{width:69,height:88,left:1368,top:350,map:[]},
sanshi_girl:{width:105,height:352,left:1360,top:175,map:[]},
twins_cat:{width:100,height:84,left:427,top:483,map:[]},
twins_girl:{width:237,height:277,left:357,top:295,map:[]},
victoria_cat:{width:61,height:82,left:755,top:376,map:[]},
victoria_girl:{width:158,height:338,left:748,top:172,map:[]},
winona_cat:{width:108,height:119,left:189,top:613,map:[]},
winona_girl:{width:271,height:311,left:40,top:469,map:[]},
zoe_cat:{width:128,height:124,left:455,top:632,map:[]},
zoe_girl:{width:358,height:241,left:385,top:539,map:[]}
    };



    var animCanv=main.find("#techearAnim");
    var animArr=[0];
    function initView(){
        //anim_max
        var i;
        for(i=1;i<=from_php.anim_max && i<=6;i++){
            main.find(".showGoodJS[data-i='"+i+"']").removeClass("unable");
            animArr.push(i);
        }
        if(from_php.anim_max==7){
             main.find(".showGoodJS[data-i='cum']").removeClass("unable");
        }



    }
    initView();
    if(animArr.length==0){
        return false;
    }
    function prepareRewardBox(){
        var box=main.find("#rewarBox");
        if(box.length==0){
            return false;
        }
        var content=box.find(".contentSelector");
        if(box.find(".iconReward").length>5){
            content.addClass("list");
            box.find(".wrapSelectorJS").myPageSelector({height:92,width:510});
            box.find(".contentSelector").blankCell(0,"iconReward blank");
        }
        else{
            content.addClass("static");
        }
        box.find("#getRewardJS").click(function(){
            box.remove();
            var to_send={page:"gameprogress","event_id":2,give_reward:1};
            $.mypost('/ajax',to_send, function(res) {
                 var data=handleAjaxRes(res);
                 if(typeof data!="undefined" && data){

                 }
             },"json");
        });
    }
    prepareRewardBox();

    girlOne=function(conf){
        PIXI.Container.call(this);
        conf=$.extend({
            girl_id:0,
            type:"girl",
            opacity:100
        },conf);
        conf.girl_name=$.takeGirlImage(conf.girl_id);
        var qconf=girl_conf[conf.girl_name+"_"+conf.type];

        var cardTexture = PIXI.utils.TextureCache[conf.type+conf.girl_id];
        var cardImg=new PIXI.Sprite(cardTexture);
        cardImg.x=qconf.left;
        cardImg.y=qconf.top;
        this.addChild(cardImg);



        this.eye=new myPixiObj.myEye({pos:[qconf.left,qconf.top],img:conf.type+"_eye"+conf.girl_id});
        this.addChild(this.eye);

        if(conf.type=="girl"){
            this.spineObj= new PIXI.spine.Spine(spineResource["tree"].spineData);
            this.spineObj.alpha=0.8;
            this.addChild(this.spineObj);
            this.spineObj.state.setAnimation(0, conf.girl_name, true);
        }


        this.alpha=conf.opacity/100;

        this.conf=conf;

        this.obj={};

    };
    girlOne.prototype = Object.create(PIXI.Container.prototype);
    girlOne.prototype= $.extend(girlOne.prototype,{
        fadeIn:function(){},
        fadeOut:function(){},
        update:function(delta){
            this.eye.update(delta);

            return 1;
        },

        remove:function(){
            this.destroy();
        }
    });



    girlBewitched=function(conf){
        PIXI.Container.call(this);
        conf=$.extend({
            girl_id:0,
            types:["girl","cat"]
        },conf);
        conf.girl_name=$.takeGirlImage(conf.girl_id);

        this.conf=conf;
        this.type;

        this.obj={};
        var i,type,opacity=100;
        for(i in conf.types){
            type=conf.types[i];
            opacity=100;
            if(type=="cat" && in_array("girl",conf.types)){
                opacity=0;
            }
            if(opacity==100){
                this.type=type;
            }
            this.obj[i]=new girlOne({type:type,girl_id:conf.girl_id,opacity:opacity});
            this.addChild(this.obj[i]);
        }

    };
    girlBewitched.prototype = Object.create(PIXI.Container.prototype);
    girlBewitched.prototype= $.extend(girlBewitched.prototype,{
        update:function(delta){
            var i;
            for(i in this.obj){
                this.obj[i].update(delta);
            }
            return 1;

        },
        remove:function(){
            var i;
            for(i in this.obj){
                this.obj[i].destroy();
            }
            this.destroy();
        }
    });








    function spineBox() {
        PIXI.Container.call(this);
        this.step=0;
        this.step_max=0;
        this.dir=0;
        this.myVal=40;
    };
    spineBox.prototype = Object.create(PIXI.Container.prototype);
    spineBox.prototype= $.extend(spineBox.prototype,{
        myUpdate:function(delta){
            if(this.dir==0){
                return false;
            }
            this.step+=this.dir*delta;
            var alpha=this.step/this.myVal;
            alpha=Math.min(1,alpha);
            alpha=Math.max(0,alpha);
            this.alpha=alpha;
            if(this.step<0 || this.step>this.myVal){
                this.dir=0;
            }
        },
        myShow:function(){
            this.step_max=this.myVal;
            this.step=0;
            this.dir=1;
        },
        myHide:function(){
            this.step_max=0;
            this.dir=-1;
            this.step=this.myVal;
        }
    });
    function spineObj(spineData){
        PIXI.spine.Spine.call(this,spineData);
        this.step=0;
        this.step_max=0;
        this.dir=0;
        this.myVal=40;
    }
    spineObj.prototype = Object.create(PIXI.spine.Spine.prototype);
    spineObj.prototype= $.extend(spineObj.prototype,{
        myUpdate:function(delta){
            if(this.dir==0){
                return false;
            }
            this.step+=this.dir*delta;
            var alpha=this.step/this.myVal;
            alpha=Math.min(1,alpha);
            alpha=Math.max(0,alpha);
            this.alpha=alpha;
            if(this.step<0){
                this.state.setEmptyAnimation(0);
            }
            if(this.step<0 || this.step>this.myVal){
                this.dir=0;
            }
        },
        myShow:function(){
            this.step_max=this.myVal;
            this.step=0;
            this.dir=1;
        },
        myHide:function(){
            this.step_max=0;
            this.dir=-1;
            this.step=this.myVal;
        }
    });

    function animTeacher(animCanv,anim_ava){
        if(anim_ava.length==0){
            return false;
        }
        this.anim_conf={
            "0":{y:0,x:0},
            "1":{y:0,x:0},
            "2":{y:0,x:0},
            "3":{y:0,x:0},
            "4":{y:0,x:0},
            "5":{y:0,x:0},
            "6":{y:0,x:0},
        };
        this.app=new PIXI.Application({
            width: 1280, height: 780,antialias: true,transparent:true,
            view:animCanv[0]
        });
        this.mainCointainer=new PIXI.Container();
        this.app.stage.addChild(this.mainCointainer);
        this.spineArr={};
        this.containerSpine=new spineBox();
        this.state=0;//number or cum;
        this.anim_ava=copyArray(anim_ava);
        this.anim_id=-1;
        var app=this.app;
        this.isCum=0;
        this.cumEnded=0;
        this.curSound="";
        this.soundIndex=_moduleTimeHandler.getNewIndex();


        this.width_all=0;
        this.left_all=0;
        this.scroll_range=[];

        var loaderMain = new PIXI.loaders.Loader();
        var i,bum;
        var loaderOptions = {
            crossOrigin: true
        };
        loaderMain.
        add("fairy",_IMG_SERV+"/gfx/place/hallanim/fairy/skeleton.json").
        add("liquid",_IMG_SERV+"/gfx/place/hallanim/liquid/skeleton.json").
        add("tree",_IMG_SERV+"/gfx/place/hallanim/tree/skeleton.json").
        add("back",_IMG_SERV+"/gfx/place/hallanim/back.jpg",loaderOptions);
        var girl_name,girl_id;
        for(girl_id=1;girl_id<=20;girl_id++){
            girl_name=$.takeGirlImage(girl_id);
            loaderMain.add("cat"+girl_id,_IMG_SERV+"/gfx/place/hallanim/girls/"+girl_name+"_cat/girl.png",loaderOptions);
            loaderMain.add("cat_eye"+girl_id,_IMG_SERV+"/gfx/place/hallanim/girls/"+girl_name+"_cat/eye.png",loaderOptions);

            if(in_array(girl_id,from_php.girls_lick)){
                loaderMain.add("girl"+girl_id,_IMG_SERV+"/gfx/place/hallanim/girls/"+girl_name+"_girl/girl.png",loaderOptions);
                loaderMain.add("girl_eye"+girl_id,_IMG_SERV+"/gfx/place/hallanim/girls/"+girl_name+"_girl/eye.png",loaderOptions);
            }
        }




        loaderMain.load(function(loader, resources){
            spineResource=resources;



            _moduleEvents.one("moduleClear",function(){
                loaderMain.reset();
            });



            animCanv.trigger("was_loaded");

        });
        _moduleEvents.one("moduleClear",function(){
            if(typeof app!="undefined" && app!=null){
                app.destroy();
            }
        });
        return this;
    };
    animTeacher.prototype={
        init:function(){

            var cardTexture = PIXI.utils.TextureCache["back"];
            var cardImg=new PIXI.Sprite(cardTexture);
            this.width_all=cardImg.width;
            this.handleScroll();
            this.mainCointainer.addChild(cardImg);



            var thisObj=this;
            this.main_ticker=this.app.ticker.add(
                function(delta){thisObj.gameLoop(delta);}
            );
            var i,anim_id,conf;

            for(i in this.anim_ava){
                anim_id=this.anim_ava[i];
                this.spineArr[anim_id]=new spineObj(spineResource["fairy"].spineData);
                conf=this.anim_conf[anim_id];
                this.spineArr[anim_id].x=conf.x;
                this.spineArr[anim_id].y=conf.y;
                this.spineArr[anim_id].alpha=0;

                this.containerSpine.addChild(this.spineArr[anim_id]);
            }





            this.girlCointainer=new PIXI.Container();


            this.girlObjArr={};
            this.addGirls();

            this.mainCointainer.addChild(this.girlCointainer);




            var liquidSpine=new PIXI.spine.Spine(spineResource["liquid"].spineData);
            liquidSpine.state.setAnimation(0,"animacja"+Math.min(intval(from_php.anim_max),6), true);
            this.mainCointainer.addChild(liquidSpine);

            this.mainCointainer.addChild(this.containerSpine);

            this.showAnim(this.anim_ava[0]);

            this.handleScroll();
        },
        handleScroll:function(){
            var scroll_range=[-(this.width_all-1280),0];
            var left_all=-(this.width_all-1280)/2;
            this.mainCointainer.x=left_all;

            this.mainCointainer.interactive = true;
            this.mainCointainer.buttonMode = true;

            var container=this.mainCointainer;

            var can_move=0,x_start=0;
            var left_cur;
            this.mainCointainer.on("mousemove",function(e){
                if(can_move){
                    left_cur=left_all-(x_start-e.data.global.x);

                    left_cur=Math.min(left_cur,scroll_range[1]);
                    left_cur=Math.max(left_cur,scroll_range[0]);

                    container.x=left_cur;
                    left_all=left_cur;
                    x_start=e.data.global.x;
                }
            });
            this.mainCointainer.on("touchmove",function(e){
                if(can_move){
                    left_cur=left_all-(x_start-e.data.global.x);

                    left_cur=Math.min(left_cur,scroll_range[1]);
                    left_cur=Math.max(left_cur,scroll_range[0]);

                    container.x=left_cur;
                    left_all=left_cur;
                    x_start=e.data.global.x;
                }
            });
            this.mainCointainer.on("pointerdown",function(e){
                if(can_move==0){
                    x_start=e.data.global.x;
                    can_move=1;
                }
            });
            this.mainCointainer.on("pointerup",function(e){
               can_move=0;
            });
            this.mainCointainer.on("pointerupoutside",function(e){
               can_move=0;
            });
        },
        addGirls:function(){
            var girl_id,girl_name,types,i;

            var girl_order=["pantress","winona","zoe","ice","cindy","geeky","emma",
            "cherry","maggie","dora","sanshi","anya","twins","lola","linn","ashley",
            "frecly","indira","victoria","alice"
            ];
            girl_order.reverse();

            for(i in girl_order){

                    girl_name=girl_order[i];
                    girl_id=$.takeGirlId(girl_name);
                    types=["cat"];
                    if(in_array(girl_id,from_php.girls_lick)){
                        types.push("girl");
                    }
                    this.girlObjArr[girl_name]=new girlBewitched(
                        {types:copyArray(types),girl_id:girl_id}
                    );
                    this.girlCointainer.addChild(this.girlObjArr[girl_name]);
            }



        },

        playSound:function(type_id){
            _moduleTimeHandler.clear(this.soundIndex);
            var type2obj={
                "0":{name:"girl_scared","duration":0},
                "1":{name:"girl_scared","duration":0},
                "2":{name:"girl_moan","duration":5000},
                "3":{name:"girl_smile","duration":6000},
                "4":{name:"pvpsuck","duration":1000},
                "5":{name:"girl_moan","duration":3000},
                "6":{name:"girl_play","duration":0},
                "cum":{name:"girl_moan","duration":0},
                "stop":{name:"","duration":0}
            };
            var nameObj=type2obj[type_id];
            if(this.curSound){
                _mySound.stopSound(this.curSound);
            }
            if(nameObj.name){

                var thc=this;
                if(nameObj.duration){
                    _moduleTimeHandler.set(this.soundIndex,function(){
                        thc.curSound=_mySound.playSound(nameObj.name);
                    },nameObj.duration);
                }
                else{
                    this.curSound=_mySound.playSound(nameObj.name);
                }
            }
        },
        gameLoop:function(delta){
            var i,k,anim_id;
            for(i in this.anim_ava){
                anim_id=this.anim_ava[i];
                this.spineArr[anim_id].myUpdate(delta);
            }
            this.containerSpine.myUpdate(delta);
            for(i in this.girlObjArr){
                    this.girlObjArr[i].update(delta);
            }
        },
        showAnim:function(anim_id){
            //getCurrent
            if(this.anim_id==anim_id && !(this.isCum==1 && anim_id==6)){
//                $.qLog("f ");
                return false;
            }
            if(this.anim_id!=-1 && this.anim_id!=anim_id ){
                this.spineArr[this.anim_id].myHide();
            }
            if(this.anim_id!=anim_id){
                this.spineArr[anim_id].myShow();

            }

            this.spineArr[anim_id].state.clearListeners ();
            if(this.anim_id==anim_id && anim_id==6 && this.cumEnded==0){
                var thc=this;
                this.spineArr[6].state.addListener({
                    complete: function(){
                        thc.spineArr[6].state.setAnimation(0, 'Animacja8', true);
                        thc.playSound(6);
                        thc.spineArr[6].state.clearListeners();
                    }
                });
            }
            else{
                this.spineArr[anim_id].state.clearTracks();
                this.spineArr[anim_id].state.setAnimation(0, 'Animacja'+anim_id, true);
                this.playSound(anim_id);
            }

            this.cumEnded=0;
            this.anim_id=anim_id;
        },
        showCum:function(){
            if(this.anim_id!=6){
                this.spineArr[this.anim_id].myHide();
                this.spineArr[6].myShow();
//                this.spineArr[6].state.clearTracks();
                this.spineArr[6].state.setAnimation(0, 'Animacja8',false);
            }
            else{
                this.spineArr[6].state.clearListeners();
                if(this.cumEnded){
                    this.spineArr[6].state.setAnimation(0, 'Animacja8',false);
                }
            }
            var thc=this;
            var state=0;
            this.spineArr[6].state.addListener({
                complete: function(){

                    state++;
                    if(state==1){
                        thc.playSound("cum");
                        thc.spineArr[6].state.setAnimation(0, 'Animacja7',false);
                    }
                    if(state==2){
                        thc.spineArr[6].state.clearListeners();
                        thc.cumEnded=1;
                    }

                }
            });

//            this.spineArr[6].state.addAnimation(1, 'animation',true);
//            this.spineArr[6].state.addAnimation(2,'cum',true);
            this.anim_id=6;
            this.isCum=1;
        },
        showContainer:function(){
            this.containerSpine.myShow();
        },
        hideContainer:function(){
            this.containerSpine.myHide();
        }
    };



    var animObj=new animTeacher(animCanv,animArr);
    animCanv.one("was_loaded",function(){
        animObj.init();
        main.find(".showGoodJS").click(function(){
            var th=$(this),val=th.attr("data-i");
            if(th.is(".unable")){
                main.find(".book[g_id='1']").bookUse("show");
                return false;
            }
            if(val=="cum"){
                animObj.showCum();
            }
            else{
                animObj.showAnim(val);
            }

        });
        var anim_show=1;
        main.find("#animToggleTJS").click(function(){
           anim_show=(anim_show+1)%2;
           animObj.playSound("stop");
           if(anim_show==0){
               animObj.hideContainer();
           }
           else{
               animObj.showContainer();
           }
        });
    });


    function makeDialog(text){
        var curTextObj={},curTextArr=[];
        var animIndex={
            eye:_moduleTimeHandler.getNewIndex(),
            mouth:_moduleTimeHandler.getNewIndex(),
            extra:_moduleTimeHandler.getNewIndex()
        };

        function getNextWholeText(textArrAll){
            function prepareMouthAnim(){
//            var step=1,dir=1,step_max=girlConf["mouth"]
//            ,obj=win.find(".girlParts .m");
//            _moduleTimeHandler.clear(animIndex.mouth);
//            _moduleTimeHandler.set(animIndex.mouth,function(){
//                step+=dir;
//                if(step==step_max){
//                    dir=-1;
//                }
//                if(step==1){
//                    dir=1;
//                }
//                obj.attr("data-step",step);
//            },150,function(){
//               obj.attr("data-step",0);
//            });
            }
            function calculateWordDimensions(text, classes) {
                classes = classes || [];


                classes.push('textDimensionCalculation');

                var div = document.createElement('div');
                div.setAttribute('class', classes.join(' '));

                $(div).text(text);

                main[0].appendChild(div);

                var dimensions = {
                    width : $(div).outerWidth(),
                    height : $(div).outerHeight()
                };

                div.parentNode.removeChild(div);

                return dimensions;
            };



            curTextObj=textArrAll.shift();
            main.find(".sayBox").removeClass("hide");
            main.find(".sayBoxJS").hide().filter("[data-type='"+curTextObj.type+"']").show();
            var textArr=curTextObj.text.split(" "),textTmp=[],i;
            var textObjField=main.find(".contentSayJS");
            var textHeight=textObjField.height();
            while(textArr.length>0){
                textTmp=[];
                for(i=0;i<10;i++){
                    textTmp.push(textArr.shift());
                }
                while(textArr.length>0 && calculateWordDimensions(textTmp.join(" "),["textForSayClass"]).height<=textHeight){
                    textTmp.push(textArr.shift());
                }
                if(calculateWordDimensions(textTmp.join(" "),["textForSayClass"]).height>textHeight){
                    textArr.unshift(textTmp.pop());
                }
                curTextArr.push(textTmp.join(" "));
            }
            function nextStep(){
                textObjField.off("lBl_end,lBl_start").one("lBl_start",function(){
                    if(curTextObj.type=="girl"){
                        prepareMouthAnim();
                    }
                }).on("lBl_end",function(){
                    _moduleTimeHandler.clear(animIndex["mouth"]);
                }).letterByletter({letterTime:40,text:curTextArr.shift()},_moduleTimeHandler);
                main.find(".sayBox").trigger("nextStep");
            }

            nextStep();
            main.find(".nextTextJS").off("click.nextGN").on("click.nextGN",function(){
                if(textObjField.letterByletter("isEnd")==1){
                    if(curTextArr.length>0){
                        nextStep();
                        _mySound.playSound("page_selector");
                    }
                    else if(from_php.dialog.length>0){
                        getNextWholeText(from_php.dialog);
                    }
                    else{
                        $.goToLocation("hallninja/"+from_php.girl_id+"/");
                        main.find(".sayBox").addClass("hide");
                        main.find(".nextTextJS").off("click.nextGN");
                    }
                }
                else{
                    _mySound.playSound("page_selector");
                    textObjField.letterByletter("clear");
                }
            });
        }
        getNextWholeText(text);
    }
    if(typeof from_php.dialog!="undefined"){
        makeDialog(from_php.dialog);
    }








    _mySound.playSound("hall_back");

    _moduleEvents.one("moduleClear",function(){
        _mySound.stopSoundAll();
    });
    $.handleBottomMenu();
    $.handleSelect();
}
